import { Service, Promotion } from "@lemmonhq/types";
import { getProductIdsFromCategories } from "./item-utils";

export function doesPromotionApplyToProduct(
  services: Service[],
  promotion: Promotion,
  productId: number,
  serviceMethod?: "takeaway" | "dine-in" | "delivery",
): boolean {
  // Check service method requirement if specified
  if (serviceMethod) {
    const serviceMethodReq = promotion.requirements.find(
      (req) => req.type === "service_method",
    );
    if (serviceMethodReq && serviceMethodReq.value !== serviceMethod) {
      return false;
    }
  }

  // Only product_discount and special_price rewards can apply to individual products
  if (
    promotion.reward.type !== "product_discount" &&
    promotion.reward.type !== "special_price"
  ) {
    return false;
  }

  // For special_price rewards, check if product is in the prices map
  if (promotion.reward.type === "special_price") {
    return promotion.reward.prices[productId] !== undefined;
  }

  // For product_discount rewards, check requirements
  const productRequirements = promotion.requirements.filter(
    (req) => req.type === "product",
  );
  const categoryRequirements = promotion.requirements.filter(
    (req) => req.type === "product_category",
  );

  // If no product/category requirements, discount applies to all products
  if (productRequirements.length === 0 && categoryRequirements.length === 0) {
    return true;
  }

  // Check explicit product requirements
  for (const req of productRequirements) {
    if (req.product_ids.includes(productId)) {
      return true;
    }
  }

  // Check category requirements
  for (const req of categoryRequirements) {
    const productIdsFromCategories = getProductIdsFromCategories(
      services,
      req.category_ids,
    );
    if (productIdsFromCategories.includes(productId)) {
      return true;
    }
  }

  return false;
}
